import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { GetNewsData } from "../../../Services/UserService/User";
import Loader from "../../../../Utils/Loader";
import { Link } from "react-router-dom";

const News = () => {
  const [newsData, setNewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    GetNewsData()
      .then((response) => {
        if (response.status) {
          setNewsData(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const stripHtmlTags = (html) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  return (
    <div>
      <Content Page_title="News" button_status={false} backbutton_status={true}>
        <div className="container py-3">
          {isLoading ? (
            <Loader />
          ) : (
            <div className="row justify-content-center">
              {newsData.length > 0 ? (
                newsData.map((news, index) => (
                  <div key={index} className="col-md-4 mb-4">
                    <div
                      className="card h-100 shadow-sm"
                      style={{
                        height: "100%",
                        maxHeight: "450px",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={news.image}
                        className="card-img-top"
                        alt="News"
                        style={{ height: "200px", objectFit: "cover" }}
                        loading="lazy"
                      />
                      <div className="card-body d-flex flex-column">
                        <h5
                          className="card-title text-truncate"
                          title={news.title}
                        >
                          {news.title}
                        </h5>
                        {/* <p
                          className="card-text mb-2 text-white"
                          style={{
                            fontSize: "14px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: news.description,
                          }}
                          title={stripHtmlTags(news.description)}
                        /> */}

                        <div
                          className="card-text mb-2 text-white"
                          style={{
                            fontSize: "14px",
                            maxHeight: "200px",
                            overflowY: "auto",
                            wordBreak: "break-word",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: news.description.replace(
                              /<img/g,
                              `<img style="
                                width:100%;
                                height:auto;
                                max-height:170px;
                                object-fit:contain;
                                border-radius:6px;
                                display:block;
                                margin-bottom:8px;
                              "`,
                            ),
                          }}
                        />

                        <small className="text-white mt-auto">
                          {new Date(news.created_at).toLocaleDateString()}
                        </small>
                        <Link
                          to="/user/newsdetail"
                          state={{ newsData: news }}
                          className="btn btn-primary btn-sm mt-2"
                        >
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center mt-5">
                  <img
                    src="/assets/images/nodata.png"
                    alt="No Records Found"
                    className="w-25"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </Content>
    </div>
  );
};

export default News;
